import { DiagnosticSuite } from "@/components/diagnostic-suite";

export default function DiagnosticPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <DiagnosticSuite />
    </div>
  );
}